export const newSteps = [
    {
        id: "welcome",
        title: [
            `<p>Get started here! </p><span class="text-right">  (1/7)</span>`
        ],
        text: [
            ` 
            <p>
                From the drop-down you can select a particular disc for analysis
            </p>
            `
        ],
        attachTo: { element: ".select-disk", on: "bottom" },
        classes: "shepherd shepherd-welcome animate__animated animate__fadeIn",
        buttons: [
            {
                type: "cancel",
                classes: "shepherd-button-secondary ",
                text: "Exit"
            },
            {
                type: "next",
                text: "Next"
            }
        ]
    },
    {
        id: "axial",
        title: `<p>AXIAL Analysis </p><span class="text-right">  (2/7)</span>`,
        text:
            "Here you can select the analysis output for AXIAL plane",
        attachTo: { element: ".axial-analysis", on: "bottom" },
        classes:"animate__animated animate__fadeIn",
        buttons: [
            {
                type: "back",
                classes: "shepherd-button-secondary",
                text: "Back"
            },
            {
                type: "next",
                text: "Next"
            }
        ]
    },
    {
        id: "sagittal",
        title: `<p>SAGITTAL Analysis </p><span class="text-right">  (3/7)</span>`,
        text: [
            "Here you can select the analysis output for the SAGITTAL plane"
        ],
        attachTo: { element: ".sagittal-analysis", on: "top" },
        classes:"animate__animated animate__fadeIn",
        buttons: [
            {
                type: "back",
                classes: "shepherd-button-secondary",
                text: "Back"
            },
            {
                type: "next",
                text: "Next"
            }
        ]
    }, 
    {
        id: "sagittalview",
        title: `<p>SAGITTAL View </p><span class="text- right">  (4/7)</span>` ,
        text: "You can use the slider to change SAGITTAL slices and toggle between Original and Analysed Output",
        attachTo: { element: ".sagittal-view", on: "bottom" },
        classes:"animate__animated animate__fadeIn",
        scrollTo: true,
        buttons: [
            {
                type: "back",
                classes: "shepherd-button-secondary",
                text: "Back"
            },
            {
                type: "next",
                text: "Next"
            }
        ]
    },
    {
        id: "axialview",
        title: `<p>AXIAL View  </p><span class="text-right">  (5/7)</span>`,
        text: "You can use the slider here to change the Axial slices and switch between Original and Analysed Output",
        attachTo: { element: ".axial-view", on: "top" },
        classes:"animate__animated animate__fadeIn",
        scrollTo: true,
        buttons: [
            {
                type: "back",
                classes: "shepherd-button-secondary",
                text: "Back"
            },
            {
                type: "next",
                text: "Next"
            }
        ]
    },
    {
        id: "checkpatient",
        title: `<p>Patient Info  </p><span class="text-right">  (6/7)</span>`,
        text: "This Tab has information about the Patient's family and treatment history",
        attachTo: { element: ".check-patient", on: "bottom" },
        classes:"animate__animated animate__fadeIn",
        scrollTo: true,
        buttons: [
            {
                type: "back",
                classes: "shepherd-button-secondary",
                text: "Back"
            },
            {
                type: "next",
                text: "Next"
            }
        ]
    },
    {
        id: "report",
        title: `<p>Analysis Report and recommendations  </p><span class="text-right">  (7/7)</span>`,
        text: "You can go to the Report tab to get the full analysis and recommendations for the patient.",
        attachTo: { element: ".check-report", on: "bottom" },
        classes:"animate__animated animate__fadeIn",
        scrollTo: true,
        buttons: [
            {
                type: "back",
                classes: "shepherd-button-secondary",
                text: "Back"
            },
            {
                type: "next",
                text: "Done"
            }
        ]
    } 
];
